(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vyro-motion"] && !Shopify.designMode) return;
  try {
    (()=>{const init=()=>document.querySelectorAll('[data-vyro-video]:not([data-motion-ready])').forEach(v=>{v.dataset.motionReady='true';const mq=matchMedia('(max-width:749px)'),reduce=matchMedia('(prefers-reduced-motion:reduce)');let visible=false;v.muted=true;v.loop=true;v.controls=false;const play=()=>{if(visible&&!reduce.matches&&!document.hidden)v.play().catch(()=>{});else v.pause();};const sync=()=>{const mobile=mq.matches&&v.dataset.mobile;v.poster=mobile?v.dataset.mobilePoster:v.dataset.poster;v.src=mobile?v.dataset.mobile:v.dataset.desktop;v.autoplay=!reduce.matches;v.load();play();};sync();mq.addEventListener('change',sync);new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;play();},{threshold:.15}).observe(v);document.addEventListener('visibilitychange',play);reduce.addEventListener('change',play);});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vyro-pdp-animations"] && !Shopify.designMode) return;
  try {
    (()=>{
const players=new Set(),reduce=matchMedia('(prefers-reduced-motion: reduce)');
const init=()=>{
 const config=document.querySelector('[data-vyro-loop-config]');if(!config)return;
 const {urls}=JSON.parse(config.textContent);
 const keyFor=src=>Object.keys(urls).find(key=>new RegExp('/'+key+'\\.(?:png|webp|jpe?g)(?:[?&]|$)').test(src||''));
 document.querySelectorAll('.pdp-main-image,.vyro-feature-card>img,.pdp-story .split-image img').forEach(img=>{
  if(img.dataset.loopReady)return;
  const gallery=img.classList.contains('pdp-main-image');if(!gallery&&!keyFor(img.src))return;
  img.dataset.loopReady='true';let frame=img.parentElement;
  if(!gallery){frame=document.createElement('span');img.before(frame);frame.append(img);}frame.classList.add('vyro-loop-frame');
  const video=document.createElement('video');video.className='vyro-pdp-loop';video.muted=true;video.defaultMuted=true;video.loop=true;video.autoplay=true;video.playsInline=true;video.controls=false;video.preload='metadata';video.disablePictureInPicture=true;video.disableRemotePlayback=true;video.tabIndex=-1;
  ['autoplay','loop','muted','playsinline','webkit-playsinline'].forEach(a=>video.setAttribute(a,''));frame.append(video);
  let key=null,pending=false;
  const update=()=>{
   if(!frame.isConnected){players.delete(update);video.pause();return;}
   const r=frame.getBoundingClientRect(),onScreen=r.bottom>0&&r.top<innerHeight&&r.right>0&&r.left<innerWidth;
   const active=!!key&&!reduce.matches&&!document.hidden&&onScreen;
   video.hidden=!key||reduce.matches;
   if(key&&!reduce.matches&&r.bottom>-300&&r.top<innerHeight+300&&video.getAttribute('src')!==urls[key]){video.src=urls[key];video.load();}
   if(!active){video.pause();return;}
   video.muted=true;if(pending||!video.paused)return;
   pending=true;const attempt=video.play();if(attempt)attempt.catch(()=>{}).finally(()=>{pending=false;});else pending=false;
  };
  const sync=()=>{const next=keyFor(img.src);if(next!==key){key=next;video.pause();video.removeAttribute('src');video.load();frame.classList.remove('vyro-loop-playing');}video.poster=img.src;video.setAttribute('aria-label',img.alt);video.style.objectFit=getComputedStyle(img).objectFit;update();};
  video.addEventListener('playing',()=>frame.classList.add('vyro-loop-playing'));video.addEventListener('error',()=>frame.classList.remove('vyro-loop-playing'));
  ['loadeddata','canplay'].forEach(e=>video.addEventListener(e,update));
  new IntersectionObserver(update,{rootMargin:'300px 0px',threshold:[0,.1,.5,1]}).observe(frame);
  new MutationObserver(sync).observe(img,{attributes:true,attributeFilter:['src','alt']});players.add(update);sync();
 });
};
let queued=false;const refresh=()=>{queued=false;players.forEach(fn=>fn());};const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(refresh);}};
['scroll','resize'].forEach(e=>window.addEventListener(e,schedule,{passive:true}));
['touchstart','touchend','pointerdown'].forEach(e=>document.addEventListener(e,refresh,{passive:true}));
window.addEventListener('pageshow',refresh);document.addEventListener('visibilitychange',refresh);reduce.addEventListener('change',refresh);
const start=()=>{init();const grid=document.querySelector('.vyro-features-grid');if(grid)new MutationObserver(init).observe(grid,{childList:true,subtree:true});};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
